<!-- eslint-disable vue/no-mutating-props -->
<template>
<div>
  <div id="page">
    <section class="container-fluid breadcrumbs d-none d-md-block">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{ $t('views.login.breadcrumbpage') }}</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>

    <main id="main" class="">
      <div class="container px-xs-0 beratung">
        <div class="row">
          <div class="login-heading">
            <i aria-hidden="true" class="icon icon--lock-solid"></i>
            <div>
              <h1>{{ $t('views.login.breadcrumbpage') }}</h1>
              <small class="">{{ $t('views.appointment.loggedinas') }} {{ user }} <a class="ms-1" @click="logout">{{
                $t('views.appointment.logout') }}</a></small>
            </div>
          </div>
        </div>
        <div class="login-content logged-in">
          <ul class="login-content--subnav">
            <li v-if="$t('views.appointment.termine1') !=='Termine' " class="login-content--subnav--item" style="hyphens: manual" :class="{ active: isRouteActive('widget-appointment') }"
              @click="navigateToAppointments">
              <i aria-hidden="true" class="icon icon--calendar"></i>
              {{ $t('views.appointment.termine1') }}&shy;{{ $t('views.appointment.termine2') }}
            </li>
            <li v-else class="login-content--subnav--item" :class="{ active: isRouteActive('widget-appointment') }"
              @click="navigateToAppointments">
              <i aria-hidden="true" class="icon icon--calendar"></i>
              {{ $t('views.appointment.termine1') }}
            </li>
            <li class="login-content--subnav--item" :class="{ active: isRouteActive('widget-account') }"
              @click="navigateToAccount">
              <i aria-hidden="true" class="icon icon--user"></i>
              {{ $t('views.appointment.account') }}
            </li>
          </ul>
          <div class="login-content--main flow">
            <h2 class="h1">{{ $t('views.appointment.termine') }}</h2>
            <p class="text-muted" v-if="appointments.length == 0">{{ $t('views.appointment.keinetermine') }}
            </p>
            <ul class="appointment-list">
              <li class="appointment flow" v-for="(appointment, aindex) in appointments" :key="aindex">
                <div class="appointment--datetime">

                  <div class="appointment--datetime--item"><i aria-hidden="true" class="icon icon--calendar"></i> {{
                    new Date(appointment.startTime).toLocaleDateString("de-DE", {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })
                  }}
                  </div>
                  <div class="appointment--datetime--item"><i aria-hidden="true" class="icon icon--clock"></i>{{
                    new Date(appointment.startTime).toLocaleTimeString("de-DE", {
                      hour: '2-digit',
                      minute: '2-digit'
                    })
                  }} -
                    {{
                      new Date(appointment.endTime).toLocaleTimeString("de-DE", { hour: '2-digit', minute: '2-digit' })
                    }} {{ $t('views.appointment.uhr') }}
                  </div>
                </div>
               <!-- runningappointment ist undefined. appointment.id kommt mit-->
                <div class="appointment--buttons" v-if="!appointment.cancelled && checkInTime(appointment.endTime)">
                  <button class="btn btn-primary-custom" aria-label="Test A" @click="startAppointment(appointment)"
                  v-if="checkIfShowButton(appointment.startTime)&& !runningAppointment && appointment.type==='CHAT'">
                    {{ $t('views.appointment.btermin') }}
                  </button>
                  <button disabled class="btn btn-primary-custom" aria-label="Test B"  @click="startAppointment(appointment)"
                  v-else-if="checkIfShowButton(appointment.startTime)&& runningAppointment!=appointment.id && appointment.type==='CHAT'">
                    {{ $t('views.appointment.btermin') }}
                  </button>
                  <p class="btn btn-primary-custom btn-disabled" aria-label="Test C" v-else-if="runningAppointment === appointment.id">
                    Beratung läuft gerade
                  </p>
                  <a class="btn btn-primary-custom" aria-label="Test D" style="text-decoration: none" v-else-if="appointment.meetingVideoURL && appointment.type==='VIDEO' && checkIfShowButton(appointment.startTime) && !runningAppointment"
                  target="_blank" :href=formatURL(appointment.meetingVideoURL)>{{ $t('views.appointment.btermin') }}
                  </a>
                  <button disabled class="btn btn-primary-custom" aria-label="Test E"
                  v-else-if="appointment.type==='VIDEO' && (checkIfShowButton(appointment.startTime)|| runningAppointment)" >
                  {{ $t('views.appointment.btermin') }}
                  </button>
                  <span v-else>
                    <button  class="btn btn-primary-custom btn-disabled">
                      {{ $t('views.appointment.disabledButton') }}
                    </button>
                  </span>
                  <button v-if="!checkIfShowButton(appointment.startTime)" class="btn btn-link" @click="cancelAppointment(appointment.id)">{{
                    $t('views.appointment.cancel') }}</button>
                </div>

                <div class="appointment--consultant">
                  <strong>{{ $t('views.appointment.advisor') }}</strong> {{ appointment.advisorName }}
                  <a :href="getSearchLink(appointment.counselingCenterId)" class="d-block">{{
                    ccNames.get(appointment.counselingCenterId) }}</a>
                </div>
                <div class="appointment--type">
                  <strong>{{ $t('views.appointment.type') }}</strong> {{ appointment.type }}
                </div>
              </li>
            </ul>
            <h3 v-if="canceledAppointments?.totalCount || 0 > 0">{{ $t('views.appointment.abgesagtetermine') }}</h3>
            <ul class="appointment-list">
              <li class="appointment flow" v-for="(appointment, aindex) in canceledAppointments.content" :key="aindex">
                <div class="appointment--datetime">
                  <div class="appointment--datetime--item"><i aria-hidden="true" class="icon icon--calendar"></i> {{
                    new Date(appointment.startTime).toLocaleDateString("de-DE", {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })
                  }}
                  </div>
                  <div class="appointment--datetime--item"><i aria-hidden="true" class="icon icon--clock"></i>{{
                    new Date(appointment.startTime).toLocaleTimeString("de-DE", {
                      hour: '2-digit',
                      minute: '2-digit'
                    })
                  }} -
                    {{
                      new Date(appointment.endTime).toLocaleTimeString("de-DE", { hour: '2-digit', minute: '2-digit' })
                    }} {{ $t('views.appointment.uhr') }}
                  </div>
                </div>
                <div class="appointment--buttons">
                  <strong v-if="appointment.cancellationSource && appointment.cancellationSource == 'CLIENT'"><br />{{
                    $t('views.appointment.fromme') }}</strong>
                  <strong v-if="appointment.cancellationSource && appointment.cancellationSource == 'ADVISOR'"><br />{{
                    $t('views.appointment.from') }} {{ appointment.advisorName }} {{ $t('views.appointment.done')
                    }}</strong>
                  <strong v-if="appointment.cancellationNote"><br />{{ appointment.cancellationNote }}</strong>
                  <strong
                    v-if="checkClientCancellation(appointment) && !(appointment.cancellationSource == 'CLIENT' || appointment.cancellationSource == 'ADVISOR')"><br />{{
                      $t('views.appointment.fromme') }}</strong>
                  <strong v-if="checkClientCancellation(appointment)"><br />{{ getClientCancellation(appointment)
                    }}</strong>
                </div>
                <div class="appointment--consultant">
                  <strong>{{ $t('views.appointment.advisor') }}</strong> {{ appointment.advisorName }}
                  <a :href="getSearchLink(appointment.counselingCenterId)" class="d-block">{{
                    ccNames.get(appointment.counselingCenterId) }}</a>
                </div>
                <div class="appointment--type">
                  <strong>{{ $t('views.appointment.type') }}</strong> {{ appointment.type }}
                </div>
              </li>
            </ul>

            <div class="accordion" id="howToAccordion">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    aria-expanded="true" aria-controls="collapseOne">
                    {{ $t('views.login.sometext') }}
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                  data-bs-parent="#howToAccordion">
                  <div class="accordion-body">
                    <ol class="onb-numbered-list">
                      <li class="onb-numbered-list--item">
                        <div>
                          {{ $t('views.login.sometext1') }}
                        </div>
                      </li>
                      <li class="onb-numbered-list--item">
                        <div>
                          {{ $t('views.login.sometext2') }}
                        </div>
                      </li>
                      <li class="onb-numbered-list--item">
                        <div>
                          {{ $t('views.login.sometext3') }}
                        </div>
                      </li>
                      <li class="onb-numbered-list--item">
                        <div>
                          {{ $t('views.login.sometext4') }}
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    {{ $t('views.appointment.help') }}
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                  data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    {{ $t('views.appointment.helptext') }}
                  </div>
                </div>
              </div>
            </div>

            <div class="card recently-visited-card" v-if="counselingCenter">
              <div class="card-body flow">
                <h5 class="card-title">{{ $t('views.appointment.lastviewed') }}</h5>

                <router-link :to="'/counseling-center/' + counselingCenter?.id">{{ counselingCenter.name
                  }}</router-link>

                <div class="d-flex align-items-center" v-if="counselingCenter?.phoneCounseling">
                  <div class="icon svg-tel" aria-hidden="true"></div>
                  <a :href="formattedPhoneHref(counselingCenter?.phoneCounseling)"
                    :title="$t('views.appointment.callphone')" class="h3link">{{
                      formattedPhoneHref(counselingCenter?.phoneCounseling) }}</a>
                </div>
                <div class="d-flex align-items-center" v-else>
                  <div class="icon svg-tel" aria-hidden="true"></div>
                  <a :href="formattedPhoneHref(counselingCenter?.phone)" :title="$t('views.appointment.callphone')"
                    class="h3link">{{
                      formattedPhoneHref(counselingCenter?.phone) }}</a>
                </div>
                <h5 class="recently-visited-card&#45;&#45;hours-heading d-inline-block">{{ $t('views.appointment.when')
                  }}</h5>
                <div class="oz-list">
                  <!--
                        [
                            {
                                "dayOfWeek": "FRIDAY",
                                "openingTime": "09:00:00",
                                "closingTime": "13:00:00",
                                "description": "jeden 1. und 3. Freitag im Monat"
                            }
                        ]
                    -->
                  <div v-for="(oo, oindex) in counselingCenter.openingHours" :key="oindex"><span class="oz-day">{{
                    $t('common.weekdaysShort.' + oo.dayOfWeek?.toUpperCase()) }}</span> {{ oo.openingTime }} - {{
                        oo.closingTime }} <span class="oz-zusatz">{{ oo.description }}</span></div>
                </div>
              </div>
            </div>

            <form class="search-form">
              <h2 class="mb-2">{{ $t('views.appointment.findcc') }}</h2>

              <div class="search-form--topic">
                <label for="">{{ $t('views.appointment.topics') }}</label>
                <a class="fakedropdown form-control d-flex align-items-center" data-bs-toggle="collapse"
                  href="#collapseCheckboxenContainer" role="button" aria-expanded="false"
                  aria-controls="collapseCheckboxen">
                  <div>
                    <span class="d-none d-lg-inline-flex fake-hover">{{ $t('views.appointment.beliebig')
                      }}&nbsp;</span>{{ $t('views.appointment.selecttopics') }}
                  </div>
                  <div class="chev-icons ms-auto">
                    <div class="chev-down">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                      </svg>
                    </div>
                    <div class="chev-up">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-chevron-up" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
                      </svg>
                    </div>
                  </div>
                </a>
              </div> <!-- / -->
              <div class="search-form--region">
                <control-select v-if="availableRegions.length > 0" i18n-label="common.regions"
                  :available-values="availableRegions" v-model="regions" />

              </div>
              <div class="search-form--online-only">
                <div class="fakelabel d-none d-xl-block m-0" aria-hidden="true">&nbsp;</div>
                <div class="d-md-flex gap-4 mt-12px">
                  <!-- <div class="d-flex grid gap-2 mb-3 mb-md-0">
                    <input type="checkbox" id="onlineonly" v-model="withOnlineCounseling">
                    <label for="onlineonly" class="d-flex align-items-center mb-0 text-nowrap text-body">Mit
                      Onlineberatung</label>
                  </div> -->
                  <button type="button" class="btn btn-primary-custom w-100" @click="getSearchPageLink()">{{
                    $t('views.appointment.search') }}</button>
                </div>
              </div>
              <div class="collapse collapsible-checkbox-container" id="collapseCheckboxenContainer">
                <div class="row">

                  <div v-for="(topic, index) in lookUpValuesTopic" :key="index" class="col-12 col-md-6 col-lg-4">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" :value="topic.id" v-model="selectedTopics"
                        :id="'thema_' + index + (type != 'overlay' ? '_start' : '')">
                      <label class="form-check-label checkbox-label d-flex align-items-top"
                        :for="'thema_' + index + (type != 'overlay' ? '_start' : '')">
                        <span>{{ topic.description }}</span>
                        <!-- <span class="ms-auto pe-3">34</span> -->
                      </label>
                    </div>
                  </div>

                </div> <!-- /collapse -->
              </div> <!-- /row -->
            </form>

            <div v-if="counselingCenters && counselingCenters.totalCount && counselingCenters.totalCount > 0"
              class="col-12 px-xs-0 mt-4 mt-md-0 pe-md-0 padding-ergebnisliste-start appointment-view-ergebnisliste">
              <!-- :class="(filteredCenter.length == 0) ? 'ps-0 col-md-12 col-lg-12' : ''"> -->
              <div id="ergebnis-liste" aria-live="polite" aria-relevant="additions removals" ref="ergebnisliste"
                tabindex="0" aria-labelledby="liste-headline">
                <div class="visually-hidden" id="liste-headline">{{ $t('searchlist.listHL') }}</div>
                <Liste :cCenter=filteredCenter :topics=selectedTopics :region="regions"
                  :lang="checkedLanguageType" :cType="checkedCounselingType" :targetGroup="checkedTargetGroup"
                  :os="withOnlineCounseling" :long="long" :lat="lat" :radiusMap="radiusMap" :searchTerm="searchTerm"
                  :mini="true" @submit="findCounselingCenters" @resetfilter="resetFilter" />
              </div>
            </div> <!-- col-12 col-md-9 -->



          </div>
        </div>

      </div> <!-- /container -->
    </main>
  </div>
  <ChatControl @chat-closed="handleChatClosed" ref="chatOverlay" @chat-minimized="handleChatMinimized" :show-update="showTimeExtended" />

  <div v-if="showMaximizeButton" class="maximized-indicator" @click="maximizeChat">
    <i class="bi bi-chat-dots-fill"></i>
    Chat maximieren
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  AppointmentDto,
  CounselingCenterDetailsDto, CounselingCenterSearchResultDto, FacetResultCounselingCenterSearchResultDto,
  LegalEntityDto,
  LookupValueDto,
  ResultAppointmentDto, ResultString
} from "@/generated/openapi";

import {
  ObjectStatus,
  RegionType,
  ClientData,
  AppointmentType
} from '@/generated/openapi/api'


import appointmentService from "@/services/appointmentService";
import {
  APPOINTMENTS_SORT_VALUES,
  COUNSELING_CENTERS_SORT_VALUES,
  createDefaultTableSortOptions
} from "@/models/OnbTableColumnDefinition";
import LoadingMixin from "@/mixins/LoadingMixin";
import counselingCenterService from "@/services/counselingCenterService";
import AuthService from "@/services/authService";
import { asSortString } from "@/utils/apiUtils";
import { mapActions } from "vuex";
import ControlSelect from '@/components/controls/ControlSelect.vue';
import { SelectOption } from "@/models/SelectOption";
import Liste from '@/components/ergebnisliste/Liste.vue'
import { sanitizeUrl } from '@braintree/sanitize-url';

import ChatControl from "@/components/chat/ChatControl.vue";

interface AppointmentDtoWithMeetingURL extends AppointmentDto{
  meetingVideoURL?: string;
}


export default defineComponent({
  name: 'AppointmentView',
  emits: ['submit'],
  components: {
    ControlSelect,
    Liste,
    ChatControl
  },
  props: {

  },
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      appointments: [] as AppointmentDtoWithMeetingURL[],
      counselingCenter: {} as CounselingCenterDetailsDto | undefined,
      counselingCenters: {} as FacetResultCounselingCenterSearchResultDto,
      legalEntity: {} as LegalEntityDto,
      advisors: {} as ResultString,
      offset: 0,
      sortOptions: createDefaultTableSortOptions(COUNSELING_CENTERS_SORT_VALUES),
      appointmentsSortOptions: createDefaultTableSortOptions(APPOINTMENTS_SORT_VALUES),
      searchMessages: {},
      selectedLong: '',
      selectedLat: '',
      selectedTopics: [] as any,
      availableRegions: [
        { label: this.$t("common.region.ALL"), value: "all" } as SelectOption,
        { label: this.$t("common.region.BURGENLAND"), value: 'BURGENLAND' } as SelectOption,
        { label: this.$t("common.region.CARINTHIA"), value: 'CARINTHIA' } as SelectOption,
        { label: this.$t("common.region.LOWER_AUSTRIA"), value: 'LOWER_AUSTRIA' } as SelectOption,
        { label: this.$t("common.region.UPPER_AUSTRIA"), value: 'UPPER_AUSTRIA' } as SelectOption,
        { label: this.$t("common.region.SALZBURG"), value: 'SALZBURG' } as SelectOption,
        { label: this.$t("common.region.STYRIA"), value: 'STYRIA' } as SelectOption,
        { label: this.$t("common.region.TYROL"), value: 'TYROL' } as SelectOption,
        { label: this.$t("common.region.VORARLBERG"), value: 'VORARLBERG' } as SelectOption,
        { label: this.$t("common.region.VIENNA"), value: 'VIENNA' } as SelectOption
      ] as SelectOption[],
      type: "home",
      filteredCenter: [] as CounselingCenterSearchResultDto[],
      checkedCounselingType: [] as any,
      checkedLanguageType: [] as any,
      checkedOnlineService: [] as any,
      withOnlineCounseling: true,
      checkedTargetGroup: '',
      long: '',
      lat: '',
      radiusMap: 40,
      searchTerm: '',
      regions: 'all',
      region: '' as RegionType,
      sortCCby: '' as any,
      listTopics: '',
      ccNames: new Map(),
      ccWebsites: new Map(),
      canceledAppointments: {} as ResultAppointmentDto,
      additionalCancelledAppointments: [] as Array<AppointmentDto>,
      timer: {} as any,
      ccArea: (document && document.getElementsByTagName('body') && document.getElementsByTagName('body')[0].className == "familie") ? "FAMILIEN" : "FRAUEN",
      AppointmentType,
      chatStatusInterval: null as number | null,
      activeChatId: null as string | null,
      showMaximizeButton: false,
      currentlyStartedAppointment: {} as AppointmentDto,
      showTimeExtended: false,
      runningAppointment: undefined as string | undefined
    }
  },
  mounted() {
    // this.findAppointments();

    this.counselingCenter = undefined;
    const last = sessionStorage.getItem('lastCC');
    if (last) {
      this.getCounselingCenter(last);
    }

    if (this.messages) {
      this.searchMessages = Object.assign({}, JSON.parse(this.messages))
    }

    this.getAllLookUpValuesTopic().then(_ => {
      this.getAllRegions().then(_ => {
      }).catch(_ => {
      })
      // this.state = LoadingState.success
    }).catch(_ => {
    })

    this.timer = setInterval(() => this.findAppointments(), 60000);
  },
  beforeUnmount() {
    this.stopChatStatusPolling();
    clearInterval(this.timer);
  },
  computed: {

    user() {
      return sessionStorage.getItem('user');
    },
    lookUpValuesTopic(): Array<LookupValueDto> {
      if (this.$store.state.allLookUpValuesTopic) {
        return this.$store.state.allLookUpValuesTopic.get('topic')
      }
      return []
    },
    /* regions(): Array<RegionDto> {
      if (this.$store.state.regions) {
        return this.$store.state.regions
      }
      return []
    } */
  },
  methods: {
    ...mapActions(['getAllLookUpValuesTopic', 'getAllRegions']),
    openChatModal(token: string, username: string, appointmentEndTime: string) {
      (this.$refs.chatOverlay as any).openChat(token, username, appointmentEndTime);
    },
    handleChatMinimized(minimized: boolean) {
      this.showMaximizeButton = minimized;
    },

    maximizeChat() {
      const chatOverlay = this.$refs.chatOverlay as any;
      if (chatOverlay) {
        chatOverlay.maximizeChat();
      }
    },

    formatURL(url: string): string | undefined{
      if(url){
        return sanitizeUrl(url)
      }
      return undefined;
    },
    formattedEmailHref(email?: string): string | undefined {
      if (email) {
        return `mailto:${sanitizeUrl(email)}`;
      }
      return undefined;
    },

    formattedPhoneHref(phone?: string): string | undefined {
      if (phone) {
        return `tel:${this.sanitizePhoneNumber(phone)}`;
      }
      return undefined;
    },

    sanitizePhoneNumber(phone: string): string {
      return phone.replace(/[^0-9+()\-.\s]/g, '');
    },
    isRouteActive(basePath: string) {
      return this.$route.name?.toString().startsWith(basePath);
    },
    getEmit(...value: any) {
      this.$emit('submit', value[0], value[1], value[2], undefined, value[3]);
    },
    async logout() {
      await AuthService.logout().then(() => {
        this.navigateToAccount();
      });
    },
    navigateToAppointments() {
      this.$router.push('/')
    },
    navigateToAccount() {
      this.$router.push('/account')
    },
    cancelAppointment(id: string) {
      this.$router.push('/appointment/cancel/' + id)
    },
    startChatStatusPolling(chatId: string) {
      this.stopChatStatusPolling();

      this.chatStatusInterval = window.setInterval(async () => {
        try {
          await this.checkChatStatus(chatId);
        } catch (error) {
          console.error('Error checking chat status:', error);
        }
      }, 30000); // 30 second interval
    },
    handleChatClosed(){
      this.runningAppointment= undefined
    },
    stopChatStatusPolling() {
      if (this.chatStatusInterval) {
        clearInterval(this.chatStatusInterval);
        this.chatStatusInterval = null;
      }
    },
    async checkChatStatus(chatId: string) {
      const chatOverlay = this.$refs.chatOverlay as any;

      this.findAppointments();

      if (!chatOverlay || !chatOverlay.showChat) {
        this.stopChatStatusPolling();
        this.activeChatId = null;
      }
    },
    startAppointment(appointment: AppointmentDto) {
      if (!appointment) return;

      if (this.runningAppointment) {
        return;
      }
      this.runningAppointment= appointment.id

      this.currentlyStartedAppointment = appointment;
      this.showTimeExtended = false;

      if (appointment.type == AppointmentType.Video) {
        this.openAppointmentUrl(appointment.id)

      }

      if (appointment.type == AppointmentType.Chat && appointment.chatRoomId) {
        if (this.user) {
          const displayName = encodeURIComponent(this.user);
          this.activeChatId = appointment.chatRoomId;

          // Start polling when chat opens
          // this.startChatStatusPolling(appointment.chatRoomId);

          // Open chat
          // nur wenn noch kein anderer Chat läuft (welcher minimiert wurde und der Maximise-Button erscheint), soll ein neuer Chat geöffnet werden können
        if(this.showMaximizeButton === false){
          this.openChatModal(appointment.chatRoomId, displayName, appointment.endTime);
        }
      }
      }
    },
    resetFilter() {
      this.searchTerm = '';
      this.checkedLanguageType = []
      this.checkedCounselingType = []
      this.checkedTargetGroup = ""
      this.checkedOnlineService = [];
      this.withOnlineCounseling = true;
    },
    getSearchPageLink() {
      const account = document.getElementById('account');
      if (account) {
        const infoLink =  account.getAttribute('data-search-page-link');

        if (infoLink) {
          let params = "?os=Chat&os=Video&os=Mail";
          if (this.regions != "all") {
            if (this.regions.toLowerCase() === "wien" || this.regions.toLowerCase() === "vienna") {
              params = params + "&region=Wien";
            } else if (this.regions.toLowerCase() === "niederösterreich" || this.regions.toLowerCase() === "lower_austria") {
              params = params + "&region=Niederösterreich";
            } else if (this.regions.toLowerCase() === "oberösterreich" || this.regions.toLowerCase() === "upper_austria") {
              params = params + "&region=Oberösterreich";
            } else if (this.regions.toLowerCase() === "salzburg" || this.regions.toLowerCase() === "salzburg") {
              params = params + "&region=Salzburg";
            } else if (this.regions.toLowerCase() === "steiermark" || this.regions.toLowerCase() === "styria") {
              params = params + "&region=Steiermark";
            } else if (this.regions.toLowerCase() === "burgenland" || this.regions.toLowerCase() === "burgenland") {
              params = params + "&region=Burgenland";
            } else if (this.regions.toLowerCase() === "kärnten" || this.regions.toLowerCase() === "carinthia") {
              params = params + "&region=Kärnten";
            } else if (this.regions.toLowerCase() === "tirol" || this.regions.toLowerCase() === "tyrol") {
              params = params + "&region=Tirol";
            } else if (this.regions.toLowerCase() === "vorarlberg" || this.regions.toLowerCase() === "vorarlberg") {
              params = params + "&region=Vorarlberg";
            }
          }
          if (this.selectedTopics && this.selectedTopics.length > 0) {
            this.selectedTopics.forEach(function (topic: any) {
              // if (params == "?os=Chat&os=Video&os=Mail") {
              //   params = params + "topic=" + topic;
              // } else {
              params = params + "&topic=" + topic;
              // }
            })
          }
         //window.location.href = infoLink + "#/" + ((params != "?") ? params : "");
         window.open( (infoLink + "#/" + ((params != "?") ? params : "")),'_blank');

        }
      }
      return "";
    },
    getSearchLink(ccId: string) {
      const account = document.getElementById('account');
      if (account) {
        let infoLink = account.getAttribute('data-search-page-link');
        if (infoLink) {
          infoLink = sanitizeUrl(infoLink + "#/counseling-center/" + ccId);
          return infoLink;
        }
      }
      return "";
    },
    findCounselingCenters() {
      const topicsList = this.selectedTopics.join(",");
      if (topicsList) {
        this.listTopics = topicsList;
      }
      let selectedRegion: any = undefined;

      //bundeslandsuche
      if ((this.lat === '' || this.long === '') && this.regions !== '') {
        // region = value[1]
        // sort by plz
        this.sortCCby = 'address.zipCode:ASC'

        if (this.regions.toLowerCase() === "wien" || this.regions.toLowerCase() === "vienna") {
          selectedRegion = RegionType.Vienna
        } else if (this.regions.toLowerCase() === "niederösterreich" || this.regions.toLowerCase() === "lower_austria") {
          selectedRegion = RegionType.LowerAustria
        } else if (this.regions.toLowerCase() === "oberösterreich" || this.regions.toLowerCase() === "upper_austria") {
          selectedRegion = RegionType.UpperAustria
        } else if (this.regions.toLowerCase() === "salzburg" || this.regions.toLowerCase() === "salzburg") {
          selectedRegion = RegionType.Salzburg
        } else if (this.regions.toLowerCase() === "steiermark" || this.regions.toLowerCase() === "styria") {
          selectedRegion = RegionType.Styria
        } else if (this.regions.toLowerCase() === "burgenland" || this.regions.toLowerCase() === "burgenland") {
          selectedRegion = RegionType.Burgenland
        } else if (this.regions.toLowerCase() === "kärnten" || this.regions.toLowerCase() === "carinthia") {
          selectedRegion = RegionType.Carinthia
        } else if (this.regions.toLowerCase() === "tirol" || this.regions.toLowerCase() === "tyrol") {
          selectedRegion = RegionType.Tyrol
        } else if (this.regions.toLowerCase() === "vorarlberg" || this.regions.toLowerCase() === "vorarlberg") {
          selectedRegion = RegionType.Vorarlberg
        } else if (this.regions === 'all') {
          this.sortCCby = ''
        }

        this.region = selectedRegion;
      }

      let lat1 = undefined
      let long1 = undefined

      if (this.lat === '' || this.long === '') {
        lat1 = undefined
        long1 = undefined
      } else {
        lat1 = +this.lat
        long1 = +this.long
      }

      if (this.regions === '') { // Bitte nach PLZ aufsteigend sortieren, wenn kein Suchkriterium oder nur Beratungsthemen gesetzt sind.
        this.sortCCby = 'address.zipCode';
      }

      counselingCenterService.getCounselingCenters('', undefined, undefined, topicsList, undefined, ObjectStatus.Active, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 10000, undefined, this.sortCCby, undefined, long1, lat1, this.radiusMap, this.region).then(result => {
        this.counselingCenters = result

        if (result && result.content) {
          this.filteredCenter = result.content;
        }
      }).catch(() => {
        console.log("ERROR getting Counselingcenters");
      });

      this.pushUrl();
    },
    pushUrl() {
      this.$router.push({
        params: {
          topic: this.listTopics,
          region: this.region,
        }
      })
    },
    async getCcName(id: string) {
      let test = await counselingCenterService.getCounselingCenter(id).then(cc => {
        return cc;
      }).catch(err => {

      })
      return test;
    },
    openAppointmentUrl(id: string) {
      const appointment = this.appointments.find((a: any) => a.id === id);

      if (!appointment) return;

      let displayName = "Anonymous";

      if (this.user) {
        displayName = encodeURIComponent(this.user);
      }
    },
    findUsers(resetOffset = false) {
      appointmentService.getAdvisors().then(result => {
        this.advisors = result;
      }).catch(() => {
      })
    },
    loadMeetingVideoURLs(){
      this.appointments.filter((appointment)=>{
        return appointment.type==='VIDEO'
      }).forEach( (appointment)=>{
        appointmentService.getAppointmentMeetingUrlForClient(appointment.id, appointment).then( url => {
          appointment.meetingVideoURL=url
        })
      })
    },
    findAppointments(resetOffset = false) {

      const sortString = asSortString(this.appointmentsSortOptions);
      appointmentService.getAppointmentsPublic(999999, this.offset, sortString, false, this.ccArea || undefined).then(result => {


        // add api filter (time_until)
        let filteredAppointments = result.content?.filter((r: AppointmentDto) => this.checkInTime(r.endTime)) ?? [];

        // this tests if the client has already cancelled the appointment, but only his one, not the whole appointment.
        const filterOwnUserCancelledAppointments = filteredAppointments.filter((r: AppointmentDto) => {
          const cancelledApp = r.clients.filter((c: ClientData) => {
            return this.checkCurrentUser(c.name) && c.cancelled
          })
          if (cancelledApp.length > 0) {
            return true;
          }
          return false;
        }) as Array<AppointmentDto>;

        this.additionalCancelledAppointments = filterOwnUserCancelledAppointments;

        filteredAppointments = filteredAppointments.filter((r: AppointmentDto) => {
          const cancelledApp = r.clients.filter((c: ClientData) => {
            return this.checkCurrentUser(c.name) && c.cancelled
          })
          if (cancelledApp.length > 0) {
            return false;
          }
          return true;
        }) as Array<AppointmentDto>;

        this.appointments = filteredAppointments
        this.loadMeetingVideoURLs()

        filteredAppointments.forEach(app => {
          let cCenter: any = this.getCcName(app.counselingCenterId);

          cCenter.then((result: CounselingCenterDetailsDto) => {
            if (result) {
              const name = result?.name || "";
              this.ccNames.set(app.counselingCenterId, name)

              this.ccWebsites.set(app.counselingCenterId, sanitizeUrl(result?.homepage || ""))
            }
          })

        })

        if (this.currentlyStartedAppointment) {
          const updatedAppointment = filteredAppointments.filter((app: AppointmentDto) => {
            return app.id == this.currentlyStartedAppointment.id
          });
          if (updatedAppointment.length > 0) {
            if (updatedAppointment[0].endTime != this.currentlyStartedAppointment.endTime) {
              this.showTimeExtended = true;
            }
          }
          // this.startAppointment(this.currentlyStartedAppointment);
        }
      }).catch(() => {
      })

      appointmentService.getAppointmentsPublic(999999, this.offset, sortString, true).then(result => {
        let filteredAppointments = result.content?.filter((r: AppointmentDto) => this.checkInTime(r.endTime)) ?? [];

        if (this.additionalCancelledAppointments.length > 0) {
          filteredAppointments = filteredAppointments.concat(this.additionalCancelledAppointments);
        }

        this.canceledAppointments = {
          content: filteredAppointments,
          totalCount: filteredAppointments?.length
        } as ResultAppointmentDto;

      }).catch(() => {
      })
    },
    checkClientCancellation(appointment: AppointmentDto) {
      const clients = appointment.clients.filter((c: ClientData) => {
        return this.checkCurrentUser(c.name) && c.cancelled
      });
      if (clients.length) {
        return true;
      }
      return false;
    },
    getClientCancellation(appointment: AppointmentDto) {
      const clients = appointment.clients.filter((c: ClientData) => {
        return this.checkCurrentUser(c.name) && c.cancelled
      });
      if (clients.length) {
        return clients[0].cancellationNote;
      }
      return "";
    },
    getCounselingCenter(id: string) {
      counselingCenterService.getCounselingCenter(id).then(cc => {
        this.counselingCenter = cc;
      }).catch(err => {

      });
    },
    checkInTime(d: string): boolean {
      // Der Link zur Online-Beratung soll im Account des Klientel erst 15 Minuten vorher aufscheinen/aktiv sein.
      const currentDate = new Date();
      const inputDate = new Date(d);
      return inputDate > currentDate;
    },
    checkIfShowButton(d: string): boolean {
      // Der Link zur Online-Beratung soll im Account des Klientel erst 15 Minuten vorher aufscheinen/aktiv sein.
      const currentDate = new Date();
      const currentTime = currentDate.getTime();
      const inputDate = new Date(d);
      const inputMinus15Min = inputDate.getTime() - 900000;

      // const timer = setInterval(() => {
      //   this.checkIfShowButton(d);
      // }, 60000);

      return currentTime > inputMinus15Min;
    },
    checkCurrentUser(user: string | undefined): boolean {
      if (this.user == user) {
        return true;
      }
      return false;
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.findAppointments();
        if (this.chatStatusInterval) {
          this.stopChatStatusPolling();
        }
      }
    }
  },
});
</script>
<style scoped>
.btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
